import { createApp } from 'vue'
// import { createI18n } from 'vue-i18n'
// import LocationFinder from './modules/LocationFinder.vue'
import LocationFinder from './modules/LocationFinder.vue'
// import VueGoogleMaps from '@fawmi/vue-google-maps'
// import { vue3Debounce } from 'vue-debounce'

// const i18n = createI18n({
// 	locale: "en",
// 	fallbackLocale:"en",
// 	messages: {
// 		en: {
// 			message: {
// 				"Near Me": "Near Me",
// 				"showList": "Show List",
// 				Directions: "Directions",
// 			},
// 		},
// 	},
// 	silentTranslationWarn: false,
// 	missingWarn: false,
// });

const app = createApp(LocationFinder)

// app.use(i18n)
// app.use(vue3Debounce)
// app.directive('debounce', vue3Debounce({ lock: true }))
/*app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB6CEiOc6oTZF9YKMTPS-5yBo67xOkWcfU',
    },
    // autobindAllEvents: true,
})*/
app.mount('#LocationFinder')